'use client';

import React, { Component } from 'react';

import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import Analysis from '../reusable-components/layouts-components__seo-fintech/analysis';
import Competitors from '../reusable-components/layouts-components__seo-fintech/competitors';
import Parameters from '../reusable-components/layouts-components__seo-fintech/parameters';
import SeoErrors from '../reusable-components/layouts-components__seo-fintech/seo-errors';
import SeoHeader from '../reusable-components/layouts-components__seo-fintech/seo-header';
import TasksSeo from '../reusable-components/layouts-components__seo-fintech/tasks';
import BannerCase from '../../case-components/title-case/banner-case';
import OfferButton from '../../../../../shared/sections/OfferButton';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../core/ScrollAnimation';

export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];

class SeoFintech extends Component {
    render() {
        const casePathname = '/cases/marketing/seo-fintech';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section className="seo-fintech">
                <BannerCase
                    img="/images/pic/seo-fintech/seofintechBanner.jpg"
                    caseName="fintech-title"
                    listPath={listPath}
                />
                <SeoHeader />
                <TasksSeo />
                <Competitors />
                <Analysis />
                <Parameters />
                <SeoErrors />
                {/*<SeoFintechBid />*/}
                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять Команду" />
                    </FullWrapper>
                </ScrollAnimation>
                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default SeoFintech;
